import { memo as Memo, useRef, useCallback, useEffect } from 'react';

//* Styles
import VideoStyle from './style';

const Video = Memo(({ data }) => {
	//! Refs
	const vidRef = useRef(null);

	//! Scroll Listener
	useEffect(() => {
		window.addEventListener('scroll', onScroll);

		return () => {
			window.removeEventListener('scroll', onScroll);
		};
	}, []);

	//! Scroll Function for Video Autoplay
	const onScroll = useCallback(() => {
		if (vidRef.current) {
			const videoObj = vidRef?.current?.getBoundingClientRect();
			const videoOfsB = videoObj.y + videoObj.height;
			const videoPlayP = window.innerHeight * 0.8;
			const videoOnScreen = (videoObj.y + videoObj.height > 0 && videoObj.y < videoPlayP) || (videoOfsB > 0 && videoOfsB < videoPlayP);

			if (videoOnScreen && vidRef.current.paused) {
				vidRef.current.play();
			} else if (!videoOnScreen && !vidRef.current.paused) {
				vidRef.current.pause();
			}
		}
	}, []);

	return (
		<VideoStyle className={'videoWrap'}>
			<div className={'videoInnerWrap'}>
				<video
					loop
					muted
					src={data}
					playsInline
					ref={vidRef}
					type='video/mp4'
				/>
			</div>
		</VideoStyle>
	);
});

export default Video;
